<h2 class="content-heading">Top Partner Program</h2>
<div class="row gutters-tiny">
  <div class="col-md-3">
    <app-top-partner-registration [housing]="housingInfoService.getSelectedHousing()"></app-top-partner-registration>
  </div>
</div>
